import type { TimingSheet } from "@szerviz/core";

/**
 * Demo data of the own timing sheet (VW group 1.9 TDI PD engine): what the in memory store
 * "finds" in the timing lookup (tests, demo, help screenshots). Not customer data, not checked
 * workshop data: a real sheet always comes from the AI lookup with its sources.
 */
export const DEMO_TIMING_SHEET: TimingSheet = {
  drive: "belt",
  interval: "120 000 km vagy 5 év, ami előbb jön",
  parts: ["Fogasszíj", "Feszítőgörgő", "Terelőgörgők", "Vízpumpa", "Hosszbordás szíj"],
  tools: ["Vezérműtengely rögzítő csap 3359", "Főtengely rögzítő T10050", "Feszítőgörgő rögzítő T10008"],
  steps: [
    "Forgassa a főtengelyt forgásirányba felső holtpontra, a jelölések fedésben legyenek.",
    "Rögzítse a főtengelyt (T10050) és a vezérműtengely agyát (3359).",
    "Lazítsa meg a vezérműtengely lánckerék csavarjait és a feszítőgörgőt, vegye le a régi szíjat.",
    "Szerelje fel az új görgőket, a vízpumpát, majd az új szíjat a főtengelytől forgásirányban.",
    "Feszítse meg a szíjat, amíg a feszítőgörgő mutatója a jelöléshez ér, és húzza meg az anyát.",
    "Húzza meg a lánckerék csavarjait, vegye ki a rögzítőket.",
    "Forgassa át a motort kézzel kétszer forgásirányba, és ellenőrizze a jelöléseket és a feszítést.",
  ],
  torques: [
    { what: "Vezérműtengely lánckerék csavarok", value: "25 Nm" },
    { what: "Feszítőgörgő anya", value: "20 Nm + 45°" },
    { what: "Főtengely lánckerék központi csavar (új)", value: "120 Nm + 90°" },
    { what: "Rezgéscsillapító csavarok (újak)", value: "10 Nm + 90°" },
  ],
  warnings: ["A motort csak forgásirányba forgassa.", "A nyújtott csavarokat mindig cserélje újra."],
  years: "2004–2010, BXE, BKC, BLS motorkód",
  sources: [
    { url: "https://www.example.com/vezerles/vw-19-tdi-pd.pdf", role: "main" },
    { url: "https://www.example.org/timing/bxe", role: "compared" },
  ],
};
